import { render, staticRenderFns } from "./PanelMenu.vue?vue&type=template&id=ee2f7120&scoped=true&"
import script from "./PanelMenu.vue?vue&type=script&lang=js&"
export * from "./PanelMenu.vue?vue&type=script&lang=js&"
import style0 from "./PanelMenu.vue?vue&type=style&index=0&id=ee2f7120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2f7120",
  null
  
)

export default component.exports